// extracted by mini-css-extract-plugin
export var marginNegative = "_6e-5 _6e-3 _6e-1";
export var marginPositive = "_6e-4 _6e-3 _6e-1";
export var modalContent = "_6e-6";
export var samplesTable = "_6e-8";
export var samplesTableContainer = "_6e-7";
export var statBox = "_6e-a";
export var tableCell = "_6e-1";
export var tableCellCenter = "_6e-2 _6e-1";
export var tableCellRight = "_6e-3 _6e-1";
export var tableHeader = "_6e-0";
export var trackingNumber = "_6e-9";